const actions = {
	GET_FILL_IN_THE_BLANKS: 'GET_FILL_IN_THE_BLANKS',
	GET_FILL_IN_THE_BLANKS_SUCCESS: 'GET_FILL_IN_THE_BLANKS_SUCCESS',

	CREATE_NEW_QUESTION_FILL_IN_THE_BLANKS: 'CREATE_NEW_QUESTION_FILL_IN_THE_BLANKS',
	CREATE_NEW_QUESTION_FILL_IN_THE_BLANKS_SUCCESS: 'CREATE_NEW_QUESTION_FILL_IN_THE_BLANKS_SUCCESS',

	DELETE_FILL_IN_THE_BLANKS: 'DELETE_FILL_IN_THE_BLANKS',
	DELETE_FILL_IN_THE_BLANKS_SUCCESS: 'DELETE_FILL_IN_THE_BLANKS_SUCCESS',

	GET_FILL_IN_THE_BLANKS_DETAIL: 'GET_FILL_IN_THE_BLANKS_DETAIL',
	GET_FILL_IN_THE_BLANKS_DETAIL_SUCCESS: 'GET_FILL_IN_THE_BLANKS_DETAIL_SUCCESS',

	UPDATE_FILL_IN_THE_BLANKS_DETAIL: 'UPDATE_FILL_IN_THE_BLANKS_DETAIL',
	UPDATE_FILL_IN_THE_BLANKS_DETAIL_SUCCESS: 'UPDATE_FILL_IN_THE_BLANKS_DETAIL_SUCCESS',

	LISTENING_LOADING_FALSE: 'LISTENING_LOADING_FALSE',
	//#region CRUD

	getFillInTheBlanks: (model) => ({
		type: actions.GET_FILL_IN_THE_BLANKS,
		payload: { model },
	}),

	createQuesFillInTheBlanks: (body, cbSuccess, cbError) => ({
		type: actions.CREATE_NEW_QUESTION_FILL_IN_THE_BLANKS,
		payload: { body },
		cbSuccess,
		cbError,
	}),

	getFillInTheBlanksDetail: (id) => ({
		type: actions.GET_FILL_IN_THE_BLANKS_DETAIL,
		payload: { id },
	}),

	updateFillInTheBlanksDetail: (model, cbSuccess, cbError) => ({
		type: actions.UPDATE_FILL_IN_THE_BLANKS_DETAIL,
		payload: { model },
		cbSuccess,
		cbError,
	}),

	deleteFillInTheBlanks: (id, cbSuccess, cbError) => ({
		type: actions.DELETE_FILL_IN_THE_BLANKS,
		payload: { id },
		cbSuccess,
		cbError,
	}),
};

export default actions;
